import {
  axiosPost,
  axiosGet,
  axiosDelete,
  axiosPut,
} from '../plugins/axios.plugins';

const API_ENDPOINTS = {
  REPORT_PDF_BASEURL: `${process.env.VUE_APP_PDF_GENERATOR_API}`,
  WORKFLOW_BASEURL: `${process.env.VUE_APP_DATA_API}`,
  FLOW_RUNNER_BASEURL: `${process.env.VUE_APP_FLOW_RUNNER_API}`,
  WRITE_MESSAGE_BASEURL: `${process.env.VUE_APP_WRITE_MESSAGE_API}`,
};

const generatePdf = (payload) => {
  return axiosPost(`${API_ENDPOINTS.REPORT_PDF_BASEURL}/page-pdf`, payload);
};

const getWorkFlowById = (workFlowId) => {
  return axiosGet(`${API_ENDPOINTS.WORKFLOW_BASEURL}/get-flow/${workFlowId}`);
};

const runFlowById = (params = '', payload = {}) => {
  return axiosPost(
    `${API_ENDPOINTS.FLOW_RUNNER_BASEURL}/run_flow_by_id${params}`,
    payload
  );
};

const askChatGPT = (payload) => {
  return axiosPost(`${API_ENDPOINTS.WRITE_MESSAGE_BASEURL}/ask-gpt`, payload);
};

const deleteWorkflowById = (workFlowId) => {
  return axiosDelete(`${API_ENDPOINTS.WORKFLOW_BASEURL}/flow/${workFlowId}`);
};

const getWorkFlowAccessRights = (workFlowId) => {
  return axiosGet(`${API_ENDPOINTS.WORKFLOW_BASEURL}/flow/iam/${workFlowId}`);
};

const shareWorkFlow = (payload) => {
  return axiosPut(`${API_ENDPOINTS.WORKFLOW_BASEURL}/flow/share`, payload);
};

export {
  generatePdf,
  getWorkFlowById,
  runFlowById,
  askChatGPT,
  deleteWorkflowById,
  getWorkFlowAccessRights,
  shareWorkFlow,
};
